export const APP_STORE_URLS = {
  ios: 'https://apps.apple.com/us/app/sondermind-mental-health/id1475263597?ign-itscg=30200&ign-itsct=apps_box_badge',
  android: 'https://play.google.com/store/apps/details?id=com.sondermind.client&hl=en_US&gl=US&pli=1&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1',
  onelink: 'https://sondermind-app.onelink.me/YCuA/xj4gw002?deep_link_value=dashboard'
};
